function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  viewBox: "0 0 256 256"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#99a1a6",
  strokeMiterlimit: 10,
  d: "M44.898 14.5c-.398-2.2-2.296-3.8-4.5-4.3C37.102 9.5 31 9 24.398 9c-6.597 0-12.796.5-16.097 1.2-2.2.5-4.102 2-4.5 4.3C3.398 17 3 20.5 3 25s.398 8 .898 10.5c.403 2.2 2.301 3.8 4.5 4.3 3.5.7 9.5 1.2 16.102 1.2s12.602-.5 16.102-1.2c2.199-.5 4.097-2 4.5-4.3.398-2.5.898-6.102 1-10.5-.204-4.5-.704-8-1.204-10.5zM19 32V18l12.2 7z",
  fontFamily: "none",
  fontSize: "none",
  fontWeight: "none",
  style: {
    mixBlendMode: "normal"
  },
  textAnchor: "none",
  transform: "scale(5.12)"
}));
export { SvgYoutube as ReactComponent };
export default __webpack_public_path__ + "252bbbc53ee9d1bed55343fc29454253.svg";